import { Dropdown, DropdownItem } from '@platform/components';
import { RepProjectPanel } from 'lib/client/src/platformapi.schemas';
import { DeleteProjectModalContext } from '../Modals/DeleteProjectModal';
import { useContext } from 'react';
import { MyProjects, Projects } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';

interface ProjectActionDropdownProps {
  panelData: RepProjectPanel;
}

export const ProjectActionDropdown = (props: ProjectActionDropdownProps) => {
  const { panelData } = { ...props };
  const { openDeleteProjectModal } = useContext(DeleteProjectModalContext);

  const { project } = { ...panelData };
  const { id: projectId, publishingStage } = { ...project };

  const isProjectEditable = publishingStage === 'unpublished' || publishingStage === 'draft';
  const isProjectUnderReview =
    publishingStage === 'review' || publishingStage === 'revision_requested';

  const projectIsDeletable =
    !panelData.actionRequired.length &&
    !panelData.inProgress.length &&
    !panelData.inactive.length &&
    (isProjectEditable || isProjectUnderReview);

  const queryClient = useQueryClient();

  const requestReviewMutator = Projects.useRequestReview({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MyProjects.getGetOrgUserMyProjectsQueryKey(),
        });
      },
    },
  });

  const unpublishProjectMutator = Projects.useUnpublishProject({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MyProjects.getGetOrgUserMyProjectsQueryKey(),
        });
      },
    },
  });

  const cloneProjectMutator = Projects.useCloneProject({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MyProjects.getGetOrgUserMyProjectsQueryKey(),
        });
      },
    },
  });

  if (!projectId) {
    return null;
  }

  return (
    <Dropdown type={'icon'} ariaLabel='Dropdown button' iconName='dots-vertical'>
      {!isProjectEditable && (
        <DropdownItem
          onAction={() => {
            cloneProjectMutator.mutate({
              projectId,
            });
          }}
        >
          Clone
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem href={`/platform/dashboard/edit-project/${projectId}`}>Edit</DropdownItem>
      )}
      {!isProjectEditable && !panelData.completed && (
        <DropdownItem
          onAction={() => {
            unpublishProjectMutator.mutate({
              projectId,
            });
          }}
        >
          Unpublish
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem
          onAction={() => {
            requestReviewMutator.mutate({
              data: { projectId },
            });
          }}
        >
          Publish
        </DropdownItem>
      )}
      {projectIsDeletable && (
        <DropdownItem
          onAction={() => {
            openDeleteProjectModal(projectId);
          }}
        >
          Delete
        </DropdownItem>
      )}
    </Dropdown>
  );
};
